import React, { useState } from "react";
import { Dropdown, FormControl } from "react-bootstrap";
import styled from "styled-components";
import { CountryWithStateModel } from "../models";
import {
  CountryFlag,
  DropdownWrapper,
  OptionsDropdownContainer,
  StyledDropdownButton,
  StyledInput,
} from "../styles";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";

interface CountryDropdownProps {
  selectedCountry: CountryWithStateModel;
  error: boolean;
  errorMessage: string;
  onCountryChange: (countryId: string) => void;
  phoneNumber: string;
  onPhoneNumberChange: (phoneNumber: string) => void;
  className?: string;
  availableCountries: CountryWithStateModel[];
}

export const CountryPhoneWrapper = styled.div`
  width: inherit;
  ${OptionsDropdownContainer} {
    > div {
      width: 100%;
      .phone-data {
        font-size: 14px;
      }
      button {
        min-width: 50px;
        padding-right: 10px;
      }
      .input-wrapper input {
        width: 100%;
        border: none;
      }
      .custom-label {
        padding-left: 0px;
        font-size: 14px;
        line-height: 18px;
      }
    }
    /* country-dpdn will take complete width, and will be without input so requires dropdown arrow at end  */
    &.country-dpdn {
      > div {
        padding-right: 20px;
      }
      .dropdown {
        width: inherit;
      }
      .dropdown-menu {
        width: 100%;
      }
    }
  }
  .country-phone-dpdn {
    input {
      border: none !important;
    }
  }
  &.purchase-phone-dropdown {
    .country-phone-dpdn .custom-label {
      font-size: 16px;
    }
  }
  .dropdown-search-input {
    padding-top: 0px;
    padding-bottom: 2px;
    color: #555;
    border-bottom: 1px solid #ddd !important;
    border-radius: 0px;
    margin-bottom: 3px;
    &::placeholder {
      color: #ccc !important;
    }
  }
  @media (max-width: 480px) {
    &.purchase-phone-dropdown .country-phone-dpdn > div {
      width: 100%;
    }
  }
`;

const CountryPhoneDropdown: React.FC<CountryDropdownProps> = ({
  selectedCountry,
  error,
  errorMessage,
  onCountryChange,
  phoneNumber,
  onPhoneNumberChange,
  availableCountries,
  className,
}) => {
  const [searchText, setSearchText] = useState("");
  const filteredCountries = availableCountries.filter((country) =>
    country.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const selectedCountryIndex = availableCountries.findIndex(
    (country: CountryWithStateModel) => country.id === selectedCountry.id
  );

  const flagLink =
    selectedCountryIndex >= 0
      ? availableCountries[selectedCountryIndex]?.flagURL
      : "";

  const handleSelect = (eventKey: string | null) => {
    if (eventKey) {
      onCountryChange(eventKey);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <CountryPhoneWrapper className={className}>
      <OptionsDropdownContainer className="country-phone-dpdn ps-country-dpdn">
        <DropdownWrapper error={error.toString()}>
          <StyledDropdownButton
            id="dropdown-basic-button"
            title={
              selectedCountry.id ? (
                <FlexContainer
                  alignItems="center"
                  className="styled-dropdown-flex"
                >
                  <CountryFlag
                    className="country-flag"
                    src={flagLink}
                    alt={selectedCountry.name}
                  />
                  <CustomLabel
                    className="custom-label"
                    fontSize="large"
                    fontWeight="light"
                  >
                    +{selectedCountry.code}
                  </CustomLabel>
                </FlexContainer>
              ) : (
                <CustomLabel
                  fontSize="large"
                  fontWeight="light"
                  className="phone-data"
                >
                  Select
                </CustomLabel>
              )
            }
            onSelect={(eventKey: string | null) => handleSelect(eventKey)}
            variant="light"
          >
            <FormControl
              autoFocus
              placeholder="Search Country..."
              onChange={handleSearch}
              value={searchText}
              className="dropdown-search-input"
              style={{
                outline: "none",
                boxShadow: "none",
                borderColor: "transparent",
              }}
            />
            {filteredCountries.map(
              (country: CountryWithStateModel, idx: number) => {
                return (
                  <>
                    <Dropdown.Item key={country.id} eventKey={country.id}>
                      <CountryFlag src={country.flagURL} alt={country.name} />
                      <span>
                        +{country.code} {country.name}
                      </span>
                    </Dropdown.Item>
                  </>
                );
              }
            )}
          </StyledDropdownButton>
          <StyledInput
            type="text"
            placeholder="Enter Phone Number"
            value={phoneNumber}
            onChange={(e) => onPhoneNumberChange(e.target.value)}
          />
        </DropdownWrapper>
        {error && <p className="error-message">{errorMessage}</p>}
      </OptionsDropdownContainer>
    </CountryPhoneWrapper>
  );
};

export default CountryPhoneDropdown;
